import Pe from "../../../@babel/runtime/helpers/esm/extends.js";
import * as p from "react";
import it from "../../utils/esm/useId/useId.js";
import ce from "../../utils/esm/useControlled/useControlled.js";
import st from "../../utils/esm/usePreviousProps/usePreviousProps.js";
import Z from "../../utils/esm/useEventCallback/useEventCallback.js";
import lt from "../../utils/esm/setRef/setRef.js";
function ve(d) {
  return typeof d.normalize < "u" ? d.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : d;
}
function ut(d = {}) {
  const {
    ignoreAccents: S = !0,
    ignoreCase: h = !0,
    limit: v,
    matchFrom: te = "any",
    stringify: U,
    trim: H = !1
  } = d;
  return (L, {
    inputValue: q,
    getOptionLabel: b
  }) => {
    let T = H ? q.trim() : q;
    h && (T = T.toLowerCase()), S && (T = ve(T));
    const B = T ? L.filter((ne) => {
      let k = (U || b)(ne);
      return h && (k = k.toLowerCase()), S && (k = ve(k)), te === "start" ? k.indexOf(T) === 0 : k.indexOf(T) > -1;
    }) : L;
    return typeof v == "number" ? B.slice(0, v) : B;
  };
}
function ee(d, S) {
  for (let h = 0; h < d.length; h += 1)
    if (S(d[h]))
      return h;
  return -1;
}
const at = ut(), Le = 5, ct = (d) => {
  var S;
  return d.current !== null && ((S = d.current.parentElement) == null ? void 0 : S.contains(document.activeElement));
}, ft = [];
function xt(d) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: S = ct,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: h = "Mui",
    autoComplete: v = !1,
    autoHighlight: te = !1,
    autoSelect: U = !1,
    blurOnSelect: H = !1,
    clearOnBlur: L = !d.freeSolo,
    clearOnEscape: q = !1,
    componentName: b = "useAutocomplete",
    defaultValue: T = d.multiple ? ft : null,
    disableClearable: B = !1,
    disableCloseOnSelect: ne = !1,
    disabled: k,
    disabledItemsFocusable: Ne = !1,
    disableListWrap: fe = !1,
    filterOptions: Ve = at,
    filterSelectedOptions: de = !1,
    freeSolo: N = !1,
    getOptionDisabled: K,
    getOptionKey: pe,
    getOptionLabel: ge = (t) => {
      var e;
      return (e = t.label) != null ? e : t;
    },
    groupBy: z,
    handleHomeEndKeys: he = !d.freeSolo,
    id: Me,
    includeInputInList: be = !1,
    inputValue: He,
    isOptionEqualToValue: A = (t, e) => t === e,
    multiple: u = !1,
    onChange: me,
    onClose: xe,
    onHighlightChange: ye,
    onInputChange: $,
    onOpen: Oe,
    open: Re,
    openOnFocus: Fe = !1,
    options: re,
    readOnly: R = !1,
    selectOnFocus: _e = !d.freeSolo,
    value: Ue
  } = d, O = it(Me);
  let m = ge;
  m = (t) => {
    const e = ge(t);
    if (typeof e != "string") {
      if (process.env.NODE_ENV !== "production") {
        const n = e === void 0 ? "undefined" : `${typeof e} (${e})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${b} returned ${n} instead of a string for ${JSON.stringify(t)}.`);
      }
      return String(e);
    }
    return e;
  };
  const oe = p.useRef(!1), ie = p.useRef(!0), c = p.useRef(null), I = p.useRef(null), [j, qe] = p.useState(null), [w, se] = p.useState(-1), Ie = te ? 0 : -1, g = p.useRef(Ie), [r, Be] = ce({
    controlled: Ue,
    default: T,
    name: b
  }), [l, J] = ce({
    controlled: He,
    default: "",
    name: b,
    state: "inputValue"
  }), [Y, we] = p.useState(!1), W = p.useCallback((t, e) => {
    if (!(u ? r.length < e.length : e !== null) && !L)
      return;
    let o;
    if (u)
      o = "";
    else if (e == null)
      o = "";
    else {
      const i = m(e);
      o = typeof i == "string" ? i : "";
    }
    l !== o && (J(o), $ && $(t, o, "reset"));
  }, [m, l, u, $, J, L, r]), [V, ke] = ce({
    controlled: Re,
    default: !1,
    name: b,
    state: "open"
  }), [Ke, Se] = p.useState(!0), Te = !u && r != null && l === m(r), y = V && !R, a = y ? Ve(
    re.filter((t) => !(de && (u ? r : [r]).some((e) => e !== null && A(t, e)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Te && Ke ? "" : l,
      getOptionLabel: m
    }
  ) : [], E = st({
    filteredOptions: a,
    value: r,
    inputValue: l
  });
  p.useEffect(() => {
    const t = r !== E.value;
    Y && !t || N && !t || W(null, r);
  }, [r, W, Y, E.value, N]);
  const le = V && a.length > 0 && !R;
  if (process.env.NODE_ENV !== "production" && r !== null && !N && re.length > 0) {
    const t = (u ? r : [r]).filter((e) => !re.some((n) => A(n, e)));
    t.length > 0 && console.warn([`MUI: The value provided to ${b} is invalid.`, `None of the options match with \`${t.length > 1 ? JSON.stringify(t) : JSON.stringify(t[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const X = Z((t) => {
    t === -1 ? c.current.focus() : j.querySelector(`[data-tag-index="${t}"]`).focus();
  });
  p.useEffect(() => {
    u && w > r.length - 1 && (se(-1), X(-1));
  }, [r, u, w, X]);
  function ze(t, e) {
    if (!I.current || t < 0 || t >= a.length)
      return -1;
    let n = t;
    for (; ; ) {
      const o = I.current.querySelector(`[data-option-index="${n}"]`), i = Ne ? !1 : !o || o.disabled || o.getAttribute("aria-disabled") === "true";
      if (o && o.hasAttribute("tabindex") && !i)
        return n;
      if (e === "next" ? n = (n + 1) % a.length : n = (n - 1 + a.length) % a.length, n === t)
        return -1;
    }
  }
  const C = Z(({
    event: t,
    index: e,
    reason: n = "auto"
  }) => {
    if (g.current = e, e === -1 ? c.current.removeAttribute("aria-activedescendant") : c.current.setAttribute("aria-activedescendant", `${O}-option-${e}`), ye && ye(t, e === -1 ? null : a[e], n), !I.current)
      return;
    const o = I.current.querySelector(`[role="option"].${h}-focused`);
    o && (o.classList.remove(`${h}-focused`), o.classList.remove(`${h}-focusVisible`));
    let i = I.current;
    if (I.current.getAttribute("role") !== "listbox" && (i = I.current.parentElement.querySelector('[role="listbox"]')), !i)
      return;
    if (e === -1) {
      i.scrollTop = 0;
      return;
    }
    const s = I.current.querySelector(`[data-option-index="${e}"]`);
    if (s && (s.classList.add(`${h}-focused`), n === "keyboard" && s.classList.add(`${h}-focusVisible`), i.scrollHeight > i.clientHeight && n !== "mouse" && n !== "touch")) {
      const f = s, x = i.clientHeight + i.scrollTop, Q = f.offsetTop + f.offsetHeight;
      Q > x ? i.scrollTop = Q - i.clientHeight : f.offsetTop - f.offsetHeight * (z ? 1.3 : 0) < i.scrollTop && (i.scrollTop = f.offsetTop - f.offsetHeight * (z ? 1.3 : 0));
    }
  }), D = Z(({
    event: t,
    diff: e,
    direction: n = "next",
    reason: o = "auto"
  }) => {
    if (!y)
      return;
    const s = ze((() => {
      const f = a.length - 1;
      if (e === "reset")
        return Ie;
      if (e === "start")
        return 0;
      if (e === "end")
        return f;
      const x = g.current + e;
      return x < 0 ? x === -1 && be ? -1 : fe && g.current !== -1 || Math.abs(e) > 1 ? 0 : f : x > f ? x === f + 1 && be ? -1 : fe || Math.abs(e) > 1 ? f : 0 : x;
    })(), n);
    if (C({
      index: s,
      reason: o,
      event: t
    }), v && e !== "reset")
      if (s === -1)
        c.current.value = l;
      else {
        const f = m(a[s]);
        c.current.value = f, f.toLowerCase().indexOf(l.toLowerCase()) === 0 && l.length > 0 && c.current.setSelectionRange(l.length, f.length);
      }
  }), je = () => {
    const t = (e, n) => {
      const o = e ? m(e) : "", i = n ? m(n) : "";
      return o === i;
    };
    if (g.current !== -1 && E.filteredOptions && E.filteredOptions.length !== a.length && E.inputValue === l && (u ? r.length === E.value.length && E.value.every((e, n) => m(r[n]) === m(e)) : t(E.value, r))) {
      const e = E.filteredOptions[g.current];
      if (e)
        return ee(a, (n) => m(n) === m(e));
    }
    return -1;
  }, ue = p.useCallback(() => {
    if (!y)
      return;
    const t = je();
    if (t !== -1) {
      g.current = t;
      return;
    }
    const e = u ? r[0] : r;
    if (a.length === 0 || e == null) {
      D({
        diff: "reset"
      });
      return;
    }
    if (I.current) {
      if (e != null) {
        const n = a[g.current];
        if (u && n && ee(r, (i) => A(n, i)) !== -1)
          return;
        const o = ee(a, (i) => A(i, e));
        o === -1 ? D({
          diff: "reset"
        }) : C({
          index: o
        });
        return;
      }
      if (g.current >= a.length - 1) {
        C({
          index: a.length - 1
        });
        return;
      }
      C({
        index: g.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    a.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    u ? !1 : r,
    de,
    D,
    C,
    y,
    l,
    u
  ]), Je = Z((t) => {
    lt(I, t), t && ue();
  });
  process.env.NODE_ENV !== "production" && p.useEffect(() => {
    (!c.current || c.current.nodeName !== "INPUT") && (c.current && c.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${b} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${c.current} while an HTMLInputElement was expected.`, `Instead, ${b} expects an input element.`, "", b === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [b]), p.useEffect(() => {
    ue();
  }, [ue]);
  const P = (t) => {
    V || (ke(!0), Se(!0), Oe && Oe(t));
  }, F = (t, e) => {
    V && (ke(!1), xe && xe(t, e));
  }, M = (t, e, n, o) => {
    if (u) {
      if (r.length === e.length && r.every((i, s) => i === e[s]))
        return;
    } else if (r === e)
      return;
    me && me(t, e, n, o), Be(e);
  }, G = p.useRef(!1), _ = (t, e, n = "selectOption", o = "options") => {
    let i = n, s = e;
    if (u) {
      if (s = Array.isArray(r) ? r.slice() : [], process.env.NODE_ENV !== "production") {
        const x = s.filter((Q) => A(e, Q));
        x.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${b} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${x.length} matches.`].join(`
`));
      }
      const f = ee(s, (x) => A(e, x));
      f === -1 ? s.push(e) : o !== "freeSolo" && (s.splice(f, 1), i = "removeOption");
    }
    W(t, s), M(t, s, i, {
      option: e
    }), !ne && (!t || !t.ctrlKey && !t.metaKey) && F(t, i), (H === !0 || H === "touch" && G.current || H === "mouse" && !G.current) && c.current.blur();
  };
  function Ye(t, e) {
    if (t === -1)
      return -1;
    let n = t;
    for (; ; ) {
      if (e === "next" && n === r.length || e === "previous" && n === -1)
        return -1;
      const o = j.querySelector(`[data-tag-index="${n}"]`);
      if (!o || !o.hasAttribute("tabindex") || o.disabled || o.getAttribute("aria-disabled") === "true")
        n += e === "next" ? 1 : -1;
      else
        return n;
    }
  }
  const Ee = (t, e) => {
    if (!u)
      return;
    l === "" && F(t, "toggleInput");
    let n = w;
    w === -1 ? l === "" && e === "previous" && (n = r.length - 1) : (n += e === "next" ? 1 : -1, n < 0 && (n = 0), n === r.length && (n = -1)), n = Ye(n, e), se(n), X(n);
  }, De = (t) => {
    oe.current = !0, J(""), $ && $(t, "", "clear"), M(t, u ? [] : null, "clear");
  }, We = (t) => (e) => {
    if (t.onKeyDown && t.onKeyDown(e), !e.defaultMuiPrevented && (w !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(e.key) === -1 && (se(-1), X(-1)), e.which !== 229))
      switch (e.key) {
        case "Home":
          y && he && (e.preventDefault(), D({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: e
          }));
          break;
        case "End":
          y && he && (e.preventDefault(), D({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: e
          }));
          break;
        case "PageUp":
          e.preventDefault(), D({
            diff: -Le,
            direction: "previous",
            reason: "keyboard",
            event: e
          }), P(e);
          break;
        case "PageDown":
          e.preventDefault(), D({
            diff: Le,
            direction: "next",
            reason: "keyboard",
            event: e
          }), P(e);
          break;
        case "ArrowDown":
          e.preventDefault(), D({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: e
          }), P(e);
          break;
        case "ArrowUp":
          e.preventDefault(), D({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: e
          }), P(e);
          break;
        case "ArrowLeft":
          Ee(e, "previous");
          break;
        case "ArrowRight":
          Ee(e, "next");
          break;
        case "Enter":
          if (g.current !== -1 && y) {
            const n = a[g.current], o = K ? K(n) : !1;
            if (e.preventDefault(), o)
              return;
            _(e, n, "selectOption"), v && c.current.setSelectionRange(c.current.value.length, c.current.value.length);
          } else N && l !== "" && Te === !1 && (u && e.preventDefault(), _(e, l, "createOption", "freeSolo"));
          break;
        case "Escape":
          y ? (e.preventDefault(), e.stopPropagation(), F(e, "escape")) : q && (l !== "" || u && r.length > 0) && (e.preventDefault(), e.stopPropagation(), De(e));
          break;
        case "Backspace":
          if (u && !R && l === "" && r.length > 0) {
            const n = w === -1 ? r.length - 1 : w, o = r.slice();
            o.splice(n, 1), M(e, o, "removeOption", {
              option: r[n]
            });
          }
          break;
        case "Delete":
          if (u && !R && l === "" && r.length > 0 && w !== -1) {
            const n = w, o = r.slice();
            o.splice(n, 1), M(e, o, "removeOption", {
              option: r[n]
            });
          }
          break;
      }
  }, Xe = (t) => {
    we(!0), Fe && !oe.current && P(t);
  }, Ae = (t) => {
    if (S(I)) {
      c.current.focus();
      return;
    }
    we(!1), ie.current = !0, oe.current = !1, U && g.current !== -1 && y ? _(t, a[g.current], "blur") : U && N && l !== "" ? _(t, l, "blur", "freeSolo") : L && W(t, r), F(t, "blur");
  }, Ge = (t) => {
    const e = t.target.value;
    l !== e && (J(e), Se(!1), $ && $(t, e, "input")), e === "" ? !B && !u && M(t, null, "clear") : P(t);
  }, Qe = (t) => {
    const e = Number(t.currentTarget.getAttribute("data-option-index"));
    g.current !== e && C({
      event: t,
      index: e,
      reason: "mouse"
    });
  }, Ze = (t) => {
    C({
      event: t,
      index: Number(t.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), G.current = !0;
  }, et = (t) => {
    const e = Number(t.currentTarget.getAttribute("data-option-index"));
    _(t, a[e], "selectOption"), G.current = !1;
  }, tt = (t) => (e) => {
    const n = r.slice();
    n.splice(t, 1), M(e, n, "removeOption", {
      option: r[t]
    });
  }, $e = (t) => {
    V ? F(t, "toggleInput") : P(t);
  }, nt = (t) => {
    t.currentTarget.contains(t.target) && t.target.getAttribute("id") !== O && t.preventDefault();
  }, rt = (t) => {
    t.currentTarget.contains(t.target) && (c.current.focus(), _e && ie.current && c.current.selectionEnd - c.current.selectionStart === 0 && c.current.select(), ie.current = !1);
  }, ot = (t) => {
    !k && (l === "" || !V) && $e(t);
  };
  let ae = N && l.length > 0;
  ae = ae || (u ? r.length > 0 : r !== null);
  let Ce = a;
  if (z) {
    const t = /* @__PURE__ */ new Map();
    let e = !1;
    Ce = a.reduce((n, o, i) => {
      const s = z(o);
      return n.length > 0 && n[n.length - 1].group === s ? n[n.length - 1].options.push(o) : (process.env.NODE_ENV !== "production" && (t.get(s) && !e && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${b} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), e = !0), t.set(s, !0)), n.push({
        key: i,
        index: i,
        group: s,
        options: [o]
      })), n;
    }, []);
  }
  return k && Y && Ae(), {
    getRootProps: (t = {}) => Pe({
      "aria-owns": le ? `${O}-listbox` : null
    }, t, {
      onKeyDown: We(t),
      onMouseDown: nt,
      onClick: rt
    }),
    getInputLabelProps: () => ({
      id: `${O}-label`,
      htmlFor: O
    }),
    getInputProps: () => ({
      id: O,
      value: l,
      onBlur: Ae,
      onFocus: Xe,
      onChange: Ge,
      onMouseDown: ot,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": y ? "" : null,
      "aria-autocomplete": v ? "both" : "list",
      "aria-controls": le ? `${O}-listbox` : void 0,
      "aria-expanded": le,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: c,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: k
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: De
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: $e
    }),
    getTagProps: ({
      index: t
    }) => Pe({
      key: t,
      "data-tag-index": t,
      tabIndex: -1
    }, !R && {
      onDelete: tt(t)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${O}-listbox`,
      "aria-labelledby": `${O}-label`,
      ref: Je,
      onMouseDown: (t) => {
        t.preventDefault();
      }
    }),
    getOptionProps: ({
      index: t,
      option: e
    }) => {
      var n;
      const o = (u ? r : [r]).some((s) => s != null && A(e, s)), i = K ? K(e) : !1;
      return {
        key: (n = pe?.(e)) != null ? n : m(e),
        tabIndex: -1,
        role: "option",
        id: `${O}-option-${t}`,
        onMouseMove: Qe,
        onClick: et,
        onTouchStart: Ze,
        "data-option-index": t,
        "aria-disabled": i,
        "aria-selected": o
      };
    },
    id: O,
    inputValue: l,
    value: r,
    dirty: ae,
    expanded: y && j,
    popupOpen: y,
    focused: Y || w !== -1,
    anchorEl: j,
    setAnchorEl: qe,
    focusedTag: w,
    groupedOptions: Ce
  };
}
export {
  ut as createFilterOptions,
  xt as default
};
